<template>
  <div class="home">
    <div class="back-home" :style="{
      background:
        formState.loginBgType === 0
          ? formState.loginBgColor
            ? formState.loginBgColor
            : 'rgba(248, 249, 255, 1)'
          : `url(${formState.loginBg
            ? formState.loginBg
            : require('@/assets/logo_bg.png')
          }) no-repeat top`,
    }">
      <div class="view">
        <div class="view-login">
          <LanguageSwitch />
          <div class="title" :style="{
            'margin-bottom':
              JSON.parse(formConfig.loginType).length > 1 ? '20px' : '40px',
          }">
            <img v-if="formState.logoUrl" :src="formState.logoUrl" alt="" class="title_logo" />
            <h3 :class="locale == 'en-US' ? 'enBtn' : ''">{{ t('login.title') }}</h3>
          </div>
          <loginComponent ref="loginAll" v-if="
            JSON.parse(formConfig.loginType).indexOf('user') != -1 &&
            JSON.parse(formConfig.loginType).indexOf('phone') != -1 &&
            !showVerify
          ">
            <template #forgetPwd>
              <router-link v-if="formConfig.forgetPwdType == '0'" :to="{ path: `/forgetPassword` }"><a
                  class="forget-pwd">{{ t('login.forgotPassword') }}?</a></router-link>
              <a v-if="formConfig.forgetPwdType === '2'" class="forget-pwd" @click="alertMsg">{{
                t('login.forgotPassword') }}?</a>
            </template>
            <template #login>
              <a-button type="primary" :class="locale == 'en-US' ? 'btn enBtn' : 'btn'" @click="loginPt('all')">{{
                t('login.button') }}</a-button>
              <div class="agreement-checkbox">
                <a-checkbox v-model:checked="agreedToTerms">
                  <span class="agreement-text">
                    {{ t('login.aggreStr1') }}
                    <a class="agreement-link" @click.stop="openUserAgreement">《{{ t('login.userAgreement') }}》</a>
                    {{ t('login.aggreStr2') }}
                    <a class="agreement-link" @click.stop="openPrivacy">《{{ t('login.privacyPolicy') }}》</a>
                    {{ t('login.agreeStr3') }}
                  </span>
                </a-checkbox>
              </div>
            </template>
          </loginComponent>
          <loginUser ref="loginUser" v-else-if="
            JSON.parse(formConfig.loginType).indexOf('user') != -1 &&
            !showVerify
          ">
            <template #forgetPwd>
              <router-link v-if="formConfig.forgetPwdType === '0'" :to="{ path: `/forgetPassword` }"><a
                  class="forget-pwd">{{ t('login.forgotPassword') }}?</a></router-link>
              <a v-if="formConfig.forgetPwdType === '2'" class="forget-pwd" @click="alertMsg">{{
                t('login.forgotPassword') }}?</a>
            </template>
            <template #login>
              <a-button type="primary" :class="locale == 'en-US' ? 'btn enBtn' : 'btn'" @click="loginPt('user')">{{
                t('login.button') }}</a-button>
              <div class="agreement-checkbox">
                <a-checkbox v-model:checked="agreedToTerms">
                  <span class="agreement-text">
                    {{ t('login.aggreStr1') }}
                    <a class="agreement-link" @click.stop="openUserAgreement">《{{ t('login.userAgreement') }}》</a>
                    {{ t('login.aggreStr2') }}
                    <a class="agreement-link" @click.stop="openPrivacy">《{{ t('login.privacyPolicy') }}》</a>
                    {{ t('login.agreeStr3') }}
                  </span>
                </a-checkbox>
              </div>
            </template>
          </loginUser>
          <loginPhone ref="loginPhone" v-else-if="
            JSON.parse(formConfig.loginType).indexOf('phone') != -1 &&
            !showVerify
          ">
            <template #login>
              <a-button type="primary" :class="locale == 'en-US' ? 'btn enBtn' : 'btn'" @click="loginPt('phone')">{{
                t('login.button') }}</a-button>
              <div class="agreement-checkbox">
                <a-checkbox v-model:checked="agreedToTerms">
                  <span class="agreement-text">
                    {{ t('login.aggreStr1') }}
                    <a class="agreement-link" @click.stop="openUserAgreement">《{{ t('login.userAgreement') }}》</a>
                    {{ t('login.aggreStr2') }}
                    <a class="agreement-link" @click.stop="openPrivacy">《{{ t('login.privacyPolicy') }}》</a>
                    {{ t('login.agreeStr3') }}
                  </span>
                </a-checkbox>
              </div>
            </template>
          </loginPhone>
          <verify-email :verifyProp="verifyProp" ref="loginVerifyEmail" v-else-if="
            JSON.parse(formConfig.loginType).indexOf('verifyEmail') != -1 &&
            showVerify
          ">
            <template #changeAccount>
              <a class="forget-pwd" @click="changeAccount">{{ t('login.switchAccount') }}</a>
            </template>
            <template #login>
              <a-button type="primary" :disabled="!verifyProp.email" class="btn" @click="loginPt('verifyEmail')">{{
                t('login.confirmlogin') }}</a-button>
              <div class="agreement-checkbox">
                <a-checkbox v-model:checked="agreedToTerms">
                  <span class="agreement-text">
                    {{ t('login.agreeStr1') }}
                    <a class="agreement-link" @click.stop="openUserAgreement">《{{ t('login.userAgreement') }}》</a>
                    {{ t('login.agreeStr2') }}
                    <a class="agreement-link" @click.stop="openPrivacy">《{{ t('login.privacyPolicy') }}》</a>
                    {{ t('login.agreeStr3') }}
                  </span>
                </a-checkbox>
              </div>
            </template>
          </verify-email>
        </div>
      </div>
    </div>

    <div class="login-footer">
      <div class="login-footer__line">
        © 2026 {{ t('login.username') }} |
        <a class="login-footer__link" @click="openPrivacy">{{ t('login.privacyPolicy') }}</a>
      </div>
      <div class="login-footer__line">浙ICP备2025213551号</div>
    </div>

    <a-modal v-model:visible="privacyVisible" :footer="null" :width="860" centered
      :bodyStyle="{ height: '70vh', overflowY: 'hidden' }">
      <template #title>
        {{ t('login.platformPrivacyPolicy') }}
      </template>
      <div class="privacy-html">
        <div v-if="locale == 'zh-CN'">
          <h2 style="text-align: center;">临床试验云平台隐私政策</h2>
          <h3>隐私政策更新时间：2026年01月15日</h3>
          <h3>隐私政策生效时间：2026年01月15日</h3>
          <h3>隐私政策版本号：V1</h3>
          <p>
            您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，博纳西亚（杭州）医药科技有限公司（注册地址：浙江省杭州市钱塘区下沙街道和享科技中心21幢1015室，常用办公地址：安徽省合肥市蜀山区合肥创新产业园G3栋B座901。以下简称“PANACRO博纳西亚”）制定本《隐私政策》并提醒您：在使用临床试验云平台的各项服务前，请您务必仔细阅读并透彻理解本《隐私政策》，在确认充分理解并同意后方使用相关产品和服务。
          </p>
          <p>在阅读完本政策后，如您对本政策或与本政策相关的事宜有任何问题，您可通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>

          <h3>定义</h3>
          <p><strong>临床试验云平台：</strong>指PANACRO博纳西亚研发协作平台（域名：ctcloud.panacro.com）以及临床试验云平台客户端。</p>
          <p>
            <strong>用户信息：</strong>用户信息是指您注册临床试验云平台账户，使用临床试验云平台的服务以及临床试验云平台为了向您提供服务，您提交的或者临床试验云平台收集的用户信息，如姓名、联系方式等，具体详见隐私政策第二条所述的信息。
          </p>

          <h3>隐私政策</h3>
          <p>
            PANACRO博纳西亚尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了临床试验云平台提供的服务时，我们将按照本隐私政策收集、处理及披露您的信息。我们希望通过本隐私政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私政策，以帮助您了解维护自己隐私权的方式。
          </p>
          <p>如果您有任何疑问、意见或建议，请与我们联系。</p>

          <p><strong>本政策将帮助您了解以下内容：</strong></p>
          <ol>
            <li>一、本政策的适用范围</li>
            <li>二、我们如何收集和使用您的用户信息</li>
            <li>三、我们如何共享、转让、公开披露您的用户信息</li>
            <li>四、用户业务数据</li>
            <li>五、您如何管理您的用户信息</li>
            <li>六、我们如何使用cookie和同类技术</li>
            <li>七、我们如何保护和保存您的用户信息</li>
            <li>八、未成年人用户信息的特别约定</li>
            <li>九、隐私政策的更新</li>
            <li>十、如何联系我们</li>
          </ol>

          <h3>一、本政策的适用范围</h3>
          <p>1.1本隐私政策适用于临床试验云平台所有服务。服务包括但不限于向您提供页面浏览、网站登录服务。</p>
          <p>1.2本隐私政策不适用于其他第三方向您提供的服务。如临床试验云平台应用中心的服务商依托临床试验云平台向您提供服务时，您向服务商提供的信息不适用本隐私政策。</p>
          <p>1.3需要特别说明的是，作为临床试验云平台的用户，若您利用临床试验云平台的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定隐私政策。</p>

          <h3>二、我们如何收集和使用您的用户信息</h3>
          <p><strong>(一) 我们收集您的用户信息的情形</strong></p>
          <p><strong>2.1帮助您成为我们平台用户和登录</strong></p>
          <p>
            2.1.1对于您在临床试验云平台开通组织用户的管理员账户的情形，我们会收集您的【姓名、手机号码、邮箱】以及您所属组织的【名称、营业执照】，用于帮助组织用户完成管理员账号的开通。您提交的手机号码/邮箱用于您登录、密码找回时接收验证码，并且作为您与临床试验云平台指定的联系方式之一，用来接收相关业务通知（如审批任务、新产品动态通知等）。您可以在我的资料中完善您的个人基本资料，方便您更好的展示或管理您的资料，包括昵称、自我介绍。
          </p>
          <p>您知悉并保证，在您通过管理员账户向我们提供授权用户的任何个人信息之前，已经事先获得授权用户的明确授权并且已经充分告知授权用户收集、使用其个人信息的目的、范围、使用方式。</p>
          <p>
            2.1.2对于您是组织用户下属的授权用户的情形，我们会收集由您所属组织用户的管理员账户在临床试验云平台中提交的您的姓名、手机号码、邮箱、角色权限等信息，用于为您创建相应的授权用户账号，且组织用户可能会根据实际情况不时更新前述信息。在您登录临床试验云平台时，您须向我们提供用户名，设置、确认您的登录密码，并提供您的有效手机号码、姓名、个人邮箱。您提交的手机号码/邮箱用于您登录、密码找回时接收验证码，并且作为您与临床试验云平台指定的联系方式之一，用来接收相关业务通知（如审批任务、新产品动态通知等）。您可以在我的资料中完善您的个人基本资料，方便您更好的展示或管理您的资料，包括昵称、自我介绍。
          </p>

          <p><strong>2.2向您提供技术服务</strong></p>
          <p>
            2.2.1根据中华人民共和国法律，在您使用具体的技术服务时，您应通过您的账号提供您的真实身份信息。您通过临床试验云平台提供真实身份信息的，临床试验云平台为您提供了多种方式以协助您提供信息，您应根据您的身份属性选择适合的方式。如您通过临床试验云平台进行企业入驻参与CRO业务，您需向临床试验云平台提交您的企业注册地区、企业性质、企业名称和营业执照注册号。临床试验云平台将以您提交的企业注册地区、企业性质、企业名称和营业执照注册号确认您的实名信息。
          </p>
          <p>2.2.2在您使用服务过程中我们会收集以下的信息：</p>
          <p>
            2.2.2.1日志信息：当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录。
          </p>
          <p>
            2.2.2.2用户账户的支持信息：基于您使用临床试验云平台服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），临床试验云平台将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。
          </p>
          <p>
            2.2.3我们在向您提供业务功能或具体服务时，我们会按照本政策以及相应的产品服务协议隐私政策的约定收集、使用、存储、对外提供及保护您的用户信息；超出本政策以及相应的产品隐私政策约定收集您的用户信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息；如您选择不提供前述信息，将会影响到您使用相应产品，但不会影响您使用临床试验云平台基本功能和其他产品。
          </p>
          <p><strong>2.3您可自主选择提供个人信息的情形包括：</strong></p>
          <p><strong>2.3.1基于设备相册权限的附加业务功能</strong></p>
          <p>当您上传/更新账号头像、给好友发送消息图片时，我们将需要获取您的设备相册权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。
          </p>
          <p><strong>2.3.2基于设备相机权限的附加业务功能</strong></p>
          <p>当您使用拍照更换头像时，我们将需要获取您的设备相机权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。</p>
          <p><strong>2.3.3基于设备存储权限的附加业务功能</strong></p>
          <p>当您访问相册、发送文件、预览文件、保存文件时，我们将需要获取您的设备存储权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。
          </p>
          <p><strong>2.3.4基于设备电话权限的附加业务功能</strong></p>
          <p>当您浏览研究中心并点击电话联系时，我们将需要获取您的设备电话权限，便于您可以直接拨打对应的号码。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。</p>

          <p><strong>2.4我们使用您的用户信息的情形</strong></p>
          <p>我们出于如下目的，使用您提交以及我们收集的用户信息：</p>
          <p><strong>2.4.1为您建立账号</strong></p>
          <p>
            为完成账号创建，我们会使用向您收集的以下信息（统称“账户信息”）：您的手机号、账号名称/昵称、账号密码，我们将通过发送短信验证码的方式来验证您的身份是否有效；您还可以补充提供其他个人信息：邮箱，补充信息将有助于您收到跟您相关的消息动态，如果您不提供这些补充信息，不会影响您使用我们平台的基本功能。
          </p>
          <p><strong>2.5投诉建议及争议纠纷处理</strong></p>
          <p>
            当您与我们联系或提出投诉建议及争议纠纷处理申请时，为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、您参与平台服务项目所提供的信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息。
          </p>
          <p><strong>2.6其他使用您用户信息的场景</strong></p>
          <p>2.6.1为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；</p>
          <p>2.6.2我们可能以用户信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息；</p>
          <p>
            2.6.3为提高您使用我们及我们关联方、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或临床试验云平台相关协议、规则的情况，我们可能使用您的用户信息、并整合设备信息、有关网络日志以及我们关联方、合作伙伴合法分享的信息，来判断您账户进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；
          </p>
          <p>2.6.4如超出收集用户信息时所声称的目的，或者在超出具有直接或合理关联的范围使用用户信息前，我们会再次向您告知并征得您的明示同意。</p>

          <h3>三、我们如何共享、转让、公开披露您的用户信息</h3>
          <p><strong>3.1共享</strong></p>
          <p>我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</p>
          <p>3.1.1在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；</p>
          <p>3.1.2在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；</p>
          <p>对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理用户信息。</p>
          <p><strong>3.2转让</strong></p>
          <p>我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</p>
          <p>3.2.1在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；</p>
          <p>
            3.2.2在临床试验云平台与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
          </p>
          <p><strong>3.3公开披露</strong></p>
          <p>我们仅会在以下情况下，公开披露您的用户信息：</p>
          <p>3.3.1获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；</p>
          <p>3.3.2或为保护临床试验云平台及其关联方用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或临床试验云平台相关协议、规则披露关于您的用户信息。</p>
          <p><strong>3.4共享、转让、公开披露用户信息时事先征得授权同意的例外</strong></p>
          <p>以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</p>
          <p>3.4.1与国家安全、国防安全有关的；</p>
          <p>3.4.2与公共安全、公共卫生、重大公共利益有关的；</p>
          <p>3.4.3与犯罪侦查、起诉、审判和判决执行等有关的；</p>
          <p>3.4.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
          <p>3.4.5您自行向社会公众公开的个人信息；</p>
          <p>3.4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
          <p><strong>3.5个人信息副本获取权</strong></p>
          <p>如您需要您的个人信息的副本，您可以通过本《隐私政策》文末提供的方式联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。
          </p>
          <p><strong>3.6逝者近亲属的权利</strong></p>
          <p>如您不幸逝世，您的近亲属可通过客服电话、邮箱渠道联系我们，以获取相关指引来行使法律规定的合法、正当权益。</p>

          <h3>四、用户业务数据</h3>
          <p>不同于您的用户信息，对于用户业务数据临床试验云平台将按如下方式处理：</p>
          <p><strong>4.1 用户业务数据</strong></p>
          <p>
            4.1.1您通过临床试验云平台提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。临床试验云平台作为云服务提供商，我们只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。
          </p>
          <p>4.1.2您应对您的用户业务数据来源及内容负责，临床试验云平台提示您谨慎判断数据来源及内容的真实性、合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。</p>

          <h3>五、您如何管理您的用户信息</h3>
          <p>5.1您可以登录临床试验云平台或临床试验云平台查询、管理（变更、删除）使用临床试验云平台服务时而提交的基本业务信息（基本资料）和联系人信息。</p>
          <p>5.2如果您需要变更您临床试验云平台账户的用户信息或需要注销您的账户的，您需通过客服电话、邮箱方式联系临床试验云平台，按照临床试验云平台的操作文档进行操作。</p>
          <p>5.3在以下情形中，您可以向我们提出删除用户信息的请求：</p>
          <p>5.3.1如果我们处理用户信息的行为违反法律法规；</p>
          <p>5.3.2如果我们收集、使用您的用户信息，却未征得您的明确同意；</p>
          <p>5.3.3如果我们处理个人信息的行为严重违反了与您的约定。</p>
          <p>5.3.4如果您不再使用我们的产品或服务，或您主动注销了账号；</p>
          <p>5.3.5如果我们停止提供产品或者服务。</p>
          <p>
            为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。
          </p>
          <p>
            5.4每个业务功能需要一些基本的用户信息才能得以完成（见本隐私政策第二条）。除此之外，您可以在与临床试验云平台客服联系给予或收回您的授权同意。当您撤回同意后，我们将不再处理相应的用户信息。但您撤回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。
          </p>
          <p>
            5.5您也可以自行在临床试验云平台“注销账号”页面（“管理控制台-账号管理-安全设置-注销账号”）提交账户注销申请。若您为临床试验云平台用户，您可以自行在临床试验云平台“注销页面”（“我的-设置-账号管理-注销账号”）提交账户注销申请。在您主动删除用户信息之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的用户信息。
          </p>
          <p>5.6响应您关于您自身用户信息的请求</p>
          <p>
            5.7.1当您提出除“注销账号”以外的上述请求时，为保障信息安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。在验证您的身份信息后，我们将在15个工作日内做出答复。
          </p>
          <p>
            5.7.2对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（如涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。在以下情形中，按照法律法规要求，我们将无法响应您的请求：
          </p>
          <p>（1）与国家安全、国防安全直接相关的；</p>
          <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>（4）有充分证据表明您存在主观恶意或滥用权利的；</p>
          <p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
          <p>（6）涉及商业秘密的。</p>

          <h3>六、我们如何使用Cookie和同类技术</h3>
          <p>6.1为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie
            通常包含标识符、站点名称以及一些号码和字符。临床试验云平台只能读取临床试验云平台提供的cookie。您同意我们有权通过cookie技术收集您的使用、行为信息，并在经过数据脱敏使之不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。
          </p>
          <p>6.2您可根据自己的偏好管理Cookie，您也可以清除计算机上保存的所有 Cookie。大部分网络浏览器都设有阻止 Cookie
            的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</p>

          <h3>七、我们如何保护和保存您的用户信息</h3>
          <p>
            7.1临床试验云平台非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。
          </p>
          <p>7.2我们已经取得了以下认证：ISO/IEC 27001国际信息安全管理体系认证、ISO/IEC 27701 国际隐私信息管理体系认证、ISO/IEC 27017云服务信息安全管理体系认证和ISO/IEC
            27018
            公有云个人可识别信息管理体系认证。</p>
          <p>7.3我们会采取合理可行的措施，尽力避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。
          </p>
          <p>
            7.4请您使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
          </p>
          <p>
            7.5在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。
          </p>
          <p>7.6同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。</p>
          <p>7.7我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况。
          </p>
          <p>
            7.8如出现临床试验云平台产品和服务停止运营的情形，我们会采取合理措施保护您用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理。
          </p>

          <h3>八、未成年人用户信息的特别约定</h3>
          <p>8.1我们主要面向成人提供产品和服务。如您为未成年人，请不要以任何形式使用我们提供的产品和服务，亦不要以任何形式向我们提供您的个人信息。</p>
          <p>
            8.2请您知悉并理解，受制于现有技术和商业模式，我们可能在无意中收集未成年人的个人信息。如果您是未成年的监护人，且您发现我们存在未经其授权获取未成年人个人信息的情况，您可通过本政策中公示的联系方式联系我们，我们在收到通知后会及时予以核查，并在核查属实后及时删除或匿名化处理相关信息。如我们主动审查发现存在前述情形的，我们也会主动对相关个人信息予以删除或进行匿名化处理。
          </p>

          <h3>九、隐私政策的更新</h3>
          <p>9.1我们的隐私政策可能修订。</p>
          <p>9.2未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。我们会在专门页面上发布对隐私政策所做的任何修订。</p>
          <p>9.3对于重大变更，我们会使用弹窗告知的方式说明隐私政策的具体变更内容。</p>
          <p>9.4本政策所指的重大变更包括但不限于：</p>
          <p>9.4.1 我们的服务模式发生重大变化，如处理用户信息的目的、处理的用户信息类型、用户信息的使用方式等；</p>
          <p>9.4.2 我们在控制权、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
          <p>9.4.3 用户信息共享、转让或公开披露的主要对象发生变化；</p>
          <p>9.4.4 您参与用户信息处理方面的权利及其行使方式发生重大变化；</p>
          <p>9.4.5 我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
          <p>9.4.6 用户信息安全影响评估报告表明存在高风险时。</p>

          <h3>十、如何联系我们</h3>
          <p>
            您对本声明和政策内容有任何疑问和意见，或者您对临床试验云平台或本隐私政策的实践以及操作上有任何疑问和意见，请拨打客服电话（010-85591162）或通过邮件（yuan.lu@panacro.com）与我们联系，如对个人隐私保护有任何疑问或其他安全相关问题需要投诉举报，可通过公司信息安全邮箱helpdesk@panacro.com联系我们，我们将在确认您的身份后，在15个工作日内给您答复。
          </p>
          <p>如果您对我们的回复不满意，或我们对您个人信息的处理方式侵害了您的合法权益，且在您向我们反馈后我们仍拒绝改进的，您可以向公安、网安等监管部门进行投诉、举报或有管辖权的法院提起诉讼。</p>
        </div>
        <div v-else>
          <h2 style="text-align: center;">Privacy Policy for Clinical Trial Cloud Platform</h2>
          <h3>Privacy Policy Update Date: January 15, 2026</h3>
          <h3>Privacy Policy Effective Date: January 15, 2026</h3>
          <h3>Privacy Policy Version: V1</h3>
          <p>Your trust is very important to us. We fully understand the importance of user information security. In
            accordance with laws and regulations, we will adopt security measures to protect your user information in a
            secure and controllable manner. Therefore, PANACRO (Hangzhou) Pharmaceutical Technology Co., Ltd.
            (Registered
            address: Room 1015, Building 21, Hexiang Technology Center, Xiasha Street, Qiantang District, Hangzhou City,
            Zhejiang Province; Office address: Room 901, Building G3-B, Hefei Innovation Industrial Park, Shushan
            District,
            Hefei City, Anhui Province, hereinafter referred to as "PANACRO") has formulated this Privacy Policy and
            reminds
            you: before using various services of the Clinical Trial Cloud Platform, you must carefully read and
            thoroughly
            understand this Privacy Policy, and only use the relevant products and services after confirming that you
            fully
            understand and agree to it.</p>
          <p>If you have any questions about this policy or matters related to this policy after reading it, you can
            contact
            us through the feedback channels listed in the "How to Contact Us" section of this policy, and we will
            respond
            to you as soon as possible.</p>

          <h3>Definitions</h3>
          <p><strong>Clinical Trial Cloud Platform: </strong>refers to the PANACRO research and development
            collaboration
            platform（domain name: ctcloud.panacro.com）and the Clinical Trial Cloud Platform client.</p>
          <p><strong>User Information: </strong>User information refers to the information you submit when registering
            for a
            Clinical Trial Cloud Platform account, using Clinical Trial Cloud Platform services, or that the Clinical
            Trial
            Cloud Platform collects in order to provide services to you, such as name, contact information, etc. For
            details, please refer to the information described in Article 2 of this Privacy Policy.</p>

          <h3>Privacy Policy</h3>
          <p>PANACRO respects and protects user information and will treat such information with a high degree of
            diligence
            and prudence. When you use the services provided by the Clinical Trial Cloud Platform, we will collect,
            process
            and disclose your information in accordance with this Privacy Policy. We hope to clearly introduce to you
            how we
            handle your information through this Privacy Policy. Therefore, we recommend that you read this Privacy
            Policy
            in its entirety to help you understand how to protect your privacy.
          </p>
          <p>If you have any questions, comments or suggestions, please contact us.
          </p>

          <p><strong>This policy will help you understand the following: </strong></p>
          <ol style="list-style: none;">
            <li>I. Scope of Application of this Policy</li>
            <li>II. How We Collect and Use Your User Information</li>
            <li>III. How We Share, Transfer, and Publicly Disclose Your User Information</li>
            <li>IV. User Business Data</li>
            <li>V. How You Can Manage Your User Information</li>
            <li>VI. How We Use Cookies and Similar Technologies</li>
            <li>VII. How We Protect and Store Your User Information</li>
            <li>VIII. Special Provisions for Minor User Information</li>
            <li>IX. Updates to the Privacy Policy</li>
            <li>X. How to Contact Us</li>
          </ol>

          <h3>I. Scope of Application of this Policy</h3>
          <p>1.1 This Privacy Policy applies to all services of the Clinical Trial Cloud Platform. Services include, but
            are
            not limited to, providing you with page browsing and website login services.</p>
          <p>1.2 This Privacy Policy does not apply to services provided to you by other third parties. For example, if
            a
            service provider in the Clinical Trial Cloud Platform application center provides services to you through
            the
            Clinical Trial Cloud Platform, the information you provide to the service provider is not subject to this
            Privacy Policy.</p>
          <p>1.3 It is important to note that as a user of the Clinical Trial Cloud Platform, if you use the technical
            services of the Clinical Trial Cloud Platform to provide services to your own users, your business data
            belongs
            to you, and you shall enter into a separate privacy policy with your users.</p>

          <h3>II. How We Collect and Use Your User Information</h3>
          <p><strong>(A) Circumstances in which we collect your user information</strong></p>
          <p><strong>2.1 To help you become a platform user and log in</strong></p>
          <p>2.1.1 In the case where you set up an administrator account for an organizational user on the Clinical
            Trial
            Cloud Platform, we will collect your [name, mobile number, email address] and the [name, business license]
            of
            your organization to help the organizational user complete the activation of the administrator account. The
            mobile number/email address you submit is used to receive verification codes when you log in or retrieve
            your
            password, and serves as one of the contact methods designated by the Clinical Trial Cloud Platform to
            receive
            relevant business notifications (such as approval tasks, new product dynamic notifications, etc.). You may
            complete your basic personal information in "My Information" to better display or manage your information,
            including nickname and self-introduction.
          </p>
          <p>You acknowledge and warrant that before providing us with any personal information of authorized users
            through
            the administrator account, you have obtained the explicit authorization of the authorized users in advance
            and
            have fully informed them of the purpose, scope, and method of collecting and using their personal
            information.
          </p>
          <p>2.1.2 In the case where you are an authorized user subordinate to an organizational user, we will collect
            your
            name, mobile number, email address, role permissions, and other information submitted by the administrator
            account of your organizational user on the Clinical Trial Cloud Platform to create the corresponding
            authorized
            user account for you. The organizational user may update the foregoing information from time to time based
            on
            actual circumstances. When you log in to the Clinical Trial Cloud Platform, you must provide us with your
            username, set and confirm your login password, and provide your valid mobile number, name, and personal
            email
            address. The mobile number/email address you submit is used to receive verification codes when you log in or
            retrieve your password, and serves as one of the contact methods designated by the Clinical Trial Cloud
            Platform
            to receive relevant business notifications (such as approval tasks, new product dynamic notifications,
            etc.).
            You may complete your basic personal information in "My Information" to better display or manage your
            information, including nickname and self-introduction.
          </p>

          <p><strong>2.2 To provide you with technical services</strong></p>
          <p>2.2.1 In accordance with the laws of the People's Republic of China, when you use specific technical
            services,
            you must provide your true identity information through your account. If you provide true identity
            information
            through the Clinical Trial Cloud Platform, the Clinical Trial Cloud Platform provides you with various
            methods
            to assist you in providing information, and you should choose the appropriate method based on your identity
            attributes. For example, if you join the platform as an enterprise to participate in CRO business through
            the
            Clinical Trial Cloud Platform, you need to submit your business registration region, business nature,
            business
            name, and business license registration number to the Clinical Trial Cloud Platform. The Clinical Trial
            Cloud
            Platform will confirm your real-name information based on the business registration region, business nature,
            business name, and business license registration number you submit.
          </p>
          <p>2.2.2 During your use of the services, we will collect the following information:
          </p>
          <p>2.2.2.1 Log information: When you use the services provided by our website or client, we will automatically
            collect detailed information about your use of our services and save it as relevant web logs. This includes
            your
            search queries, IP address, browser type, telecommunications provider, language used, access date and time,
            and
            the web pages you visit.
          </p>
          <p>2.2.2.2 User account support information: Based on your use of the Clinical Trial Cloud Platform services,
            we
            may collect user consultation records, trouble reporting records, and troubleshooting processes (such as
            communication or call records). The Clinical Trial Cloud Platform will record and analyze this information
            to
            respond to your help requests in a more timely manner and to improve services.
          </p>
          <p>2.2.3 When we provide business functions or specific services to you, we will collect, use, store, provide
            externally, and protect your user information in accordance with this policy and the relevant product
            service
            agreement and privacy policy. If we need to collect user information beyond what is agreed in this policy
            and
            the relevant product privacy policy, we will separately explain the scope and purpose of the information
            collection and obtain your consent before collecting the information necessary to provide the corresponding
            service. If you choose not to provide the foregoing information, it will affect your use of the
            corresponding
            product, but it will not affect your use of the basic functions of the Clinical Trial Cloud Platform and
            other
            products.
          </p>

          <p><strong>2.3 Circumstances in which you may voluntarily provide personal information include:</strong></p>
          <p><strong>2.3.1 Additional business functions based on device photo album permission</strong></p>
          <p>When you upload/update your account avatar or send pictures to friends, we will need to obtain your device
            photo album permission and collect the image and video content (personal information) you provide. If you
            refuse
            to provide this, it will only prevent you from using this function, but will not affect your normal use of
            other
            functions of the product and/or service.</p>
          <p><strong>2.3.2 Additional business functions based on device camera permission</strong></p>
          <p>When you use the camera to change your avatar, we will need to obtain your device camera permission and
            collect
            the image and video content (personal information) you provide. If you refuse to provide this, it will only
            prevent you from using this function, but will not affect your normal use of other functions of the product
            and/or service.</p>
          <p><strong>2.3.3 Additional business functions based on device storage permission</strong></p>
          <p>When you access the photo album, send files, preview files, or save files, we will need to obtain your
            device
            storage permission and collect the image and video content (personal information) you provide. If you refuse
            to
            provide this, it will only prevent you from using this function, but will not affect your normal use of
            other
            functions of the product and/or service.</p>
          <p><strong>2.3.4 Additional business functions based on device phone permission</strong></p>
          <p>When you browse research centers and click to make a phone call, we will need to obtain your device phone
            permission so that you can directly dial the corresponding number. If you refuse to provide this, it will
            only
            prevent you from using this function, but will not affect your normal use of other functions of the product
            and/or service.</p>

          <p><strong>2.4 Circumstances in which we use your user information</strong></p>
          <p>We use the user information you submit and we collect for the following purposes:</p>
          <p><strong>2.4.1 To create an account for you</strong></p>
          <p>To complete account creation, we will use the following information collected from you (collectively
            "Account
            Information"): your mobile number, account name/nickname, account password. We will verify your identity by
            sending an SMS verification code. You may also voluntarily provide additional personal information: email
            address. Supplementary information will help you receive dynamic messages related to you. If you do not
            provide
            this supplementary information, it will not affect your use of the basic functions of our platform.</p>
          <p><strong>2.5 Complaints, suggestions, and dispute resolution</strong></p>
          <p>When you contact us or make a complaint, suggestion, or dispute resolution request, to facilitate
            communication, help resolve your issue as quickly as possible, or record the resolution plan and outcome of
            the
            relevant issue, we may keep records of your communication/call with us and related content (including
            account
            information, information you provided when participating in platform service projects, other information you
            provided to prove relevant facts, or your contact information). For the reasonable need to provide services
            and
            improve service quality, we may also use other information of yours, including relevant information you
            provided
            when contacting customer service.
          </p>
          <p><strong>2.6 Other scenarios in which we use your user information</strong></p>
          <p>2.6.1 To provide you with services, we will send you messages, notifications, or communicate with you for
            business purposes, including but not limited to verification codes necessary to complete the service and
            necessary push notifications when using the service.
          </p>
          <p>2.6.2 We may design, develop, and promote new products and services based on statistical data of user
            information. We may conduct statistical analysis of our service usage and share these statistical data with
            the
            public or third parties, but these statistical data will not contain any personally identifiable information
            of
            yours.
          </p>
          <p>2.6.3 To improve the security of services provided by us, our affiliates, and partners, ensure the security
            of
            the operating environment, identify abnormal account statuses, protect you and other users or the public
            from
            personal and property harm, better prevent phishing websites, fraud, network vulnerabilities, computer
            viruses,
            network attacks, intrusions, and other security risks, and more accurately identify violations of laws,
            regulations, or relevant agreements and rules of the Clinical Trial Cloud Platform, we may use your user
            information, integrate device information, relevant web logs, and information legally shared by our
            affiliates
            and partners to authenticate your account, detect and prevent security incidents, and take necessary
            records,
            audits, analysis, and disposal measures in accordance with the law.
          </p>
          <p>2.6.4 If we use your user information beyond the purpose stated at the time of collection or beyond the
            scope
            of a direct or reasonable connection, we will inform you again and obtain your explicit consent.
          </p>

          <h3>III. How We Share, Transfer, and Publicly Disclose Your User Information</h3>
          <p><strong>3.1 Sharing</strong></p>
          <p>We do not share your user information with other organizations or individuals, except in the following
            circumstances:</p>
          <p>3.1.1 Sharing with explicit consent: After obtaining your explicit consent, we will share your user
            information
            with other parties.</p>
          <p>3.1.2 Sharing under legal circumstances: We may share your user information externally in accordance with
            laws,
            regulations, litigation, arbitration, or as required by administrative or judicial authorities.</p>
          <p>For companies, organizations, and individuals with whom we share user information, we will sign strict
            confidentiality agreements and information protection agreements, requiring them to handle user information
            in
            accordance with our instructions, this Privacy Policy, and any other relevant confidentiality and security
            measures.</p>
          <p><strong>3.2 Transfer</strong></p>
          <p>We will not transfer your user information to any company, organization, or individual, except in the
            following
            circumstances:</p>
          <p>3.2.1 Transfer with explicit consent: After obtaining your explicit consent, we will transfer your user
            information to other parties.</p>
          <p>3.2.2 In the event of a merger, acquisition, or bankruptcy liquidation involving the Clinical Trial Cloud
            Platform and other legal entities, or other circumstances involving merger, acquisition, or bankruptcy
            liquidation, if the transfer of user information is involved, we will require the new company or
            organization
            that holds your user information to continue to be bound by this policy. Otherwise, we will require that
            company, organization, or individual to obtain your authorization and consent again.</p>
          <p><strong>3.3 Public Disclosure</strong></p>
          <p>We will publicly disclose your user information only in the following circumstances:</p>
          <p>3.3.1 With your explicit consent or based on your active choice, we may publicly disclose your user
            information.</p>
          <p>3.3.2 To protect the personal and property safety of Clinical Trial Cloud Platform, its affiliates, users,
            or
            the public from harm, we may disclose your user information in accordance with applicable laws or relevant
            agreements and rules of the Clinical Trial Cloud Platform.</p>
          <p><strong>3.4 Exceptions to prior authorization and consent for sharing, transfer, and public disclosure of
              user
              information</strong></p>
          <p>Your prior authorization and consent are not required for sharing, transfer, or public disclosure of your
            user
            information in the following circumstances:</p>
          <p>3.4.1 Related to national security or defense security;</p>
          <p>3.4.2 Related to public safety, public health, or major public interests;</p>
          <p>3.4.3 Related to criminal investigation, prosecution, trial, and enforcement of judgments;</p>
          <p>3.4.4 Necessary to protect the vital legitimate rights and interests of you or other individuals, such as
            life
            and property, but where it is difficult to obtain your consent;</p>
          <p>3.4.5 Personal information that you have made public to the public;</p>
          <p>3.4.6 Personal information collected from legally publicly disclosed information, such as legitimate news
            reports, government information disclosure, etc.</p>
          <p><strong>3.5 Right to Obtain a Copy of Personal Information</strong></p>
          <p>If you need a copy of your personal information, you may contact us through the means provided at the end
            of
            this Privacy Policy. After verifying your identity, we will provide you with a copy of your personal
            information
            in our services (including basic information, identity information), unless otherwise provided by laws and
            regulations or agreed in this policy.</p>
          <p><strong>3.6 Rights of Close Relatives of the Deceased</strong></p>
          <p>If you unfortunately pass away, your close relatives may contact us via customer service phone or email to
            obtain relevant guidance for exercising their legal and legitimate rights and interests.</p>

          <h3>V. How You Can Manage Your User Information</h3>
          <p>Unlike your user information, user business data will be handled by the Clinical Trial Cloud Platform as
            follows:</p>
          <p><strong>4.1 User Business Data</strong></p>
          <p>4.1.1 The data that you process, store, upload, download, distribute, or otherwise handle through the
            services
            provided by the Clinical Trial Cloud Platform are your user business data, and you own your user business
            data
            entirely. As a cloud service provider, the Clinical Trial Cloud Platform will strictly follow your
            instructions
            to process your business data. Except as agreed with you or required by explicit laws and regulations, we
            will
            not make any unauthorized use or disclosure of your business data.</p>
          <p>4.1.2 You shall be responsible for the source and content of your user business data. The Clinical Trial
            Cloud
            Platform reminds you to carefully verify the authenticity and legality of the data source and content. All
            consequences and liabilities arising from your user business data violating laws, regulations, departmental
            rules, or national policies shall be borne by you alone.</p>

          <h3>V. How You Can Manage Your User Information</h3>
          <p>5.1 You can log in to the Clinical Trial Cloud Platform to query and manage (change, delete) the basic
            business
            information (basic information) and contact information you submitted when using Clinical Trial Cloud
            Platform
            services.</p>
          <p>5.2 If you need to change your user information for your Clinical Trial Cloud Platform account or need to
            cancel your account, you need to contact the Clinical Trial Cloud Platform by customer service phone or
            email
            and follow the operation documents of the Clinical Trial Cloud Platform.</p>
          <p>5.3 Under the following circumstances, you may request us to delete your user information:</p>
          <p>5.3.1 If our processing of user information violates laws or regulations;</p>
          <p>5.3.2 If we collect or use your user information without obtaining your explicit consent;</p>
          <p>5.3.3 If our processing of personal information seriously violates the agreement with you;</p>
          <p>5.3.4 If you no longer use our products or services, or you voluntarily cancel your account;</p>
          <p>5.3.5 If we stop providing products or services.</p>
          <p>To ensure security, you may need to provide a written request or otherwise prove your identity. We may
            first
            ask you to verify your identity before processing your request. After you or we assist you in deleting
            relevant
            information, due to applicable laws and security technologies, we may not be able to immediately delete the
            corresponding information from our backup systems. We will securely store your personal information and
            isolate
            it from any further processing until the backups can be cleared or anonymized.</p>
          <p>5.4 Each business function requires some basic user information to be completed (see Article 2 of this
            Privacy
            Policy). In addition, you may give or withdraw your authorization and consent by contacting the Clinical
            Trial
            Cloud Platform customer service. After you withdraw your consent, we will no longer process the
            corresponding
            user information. However, your decision to withdraw consent will not affect the processing of user
            information
            carried out based on your authorization before the withdrawal.</p>
          <p>5.5 You may also submit an account cancellation application on the Clinical Trial Cloud Platform "Cancel
            Account" page ("Management Console - Account Management - Security Settings - Cancel Account"). If you are a
            Clinical Trial Cloud Platform user, you can submit an account cancellation application on the Clinical Trial
            Cloud Platform "Cancel Account" page ("My - Settings - Account Management - Cancel Account"). After you
            voluntarily delete your user information, we will stop providing products or services to you and delete your
            user information in accordance with applicable laws.</p>
          <p>5.6 Responding to your requests regarding your own user information</p>
          <p>5.7.1 When you make a request other than "account cancellation", to ensure information security, you may
            need
            to provide a written request or otherwise prove your identity. We may first ask you to verify your identity
            before processing your request. After verifying your identity, we will respond within 15 working days.</p>
          <p>5.7.2 For reasonable requests, we generally do not charge a fee. However, for repeated requests or requests
            that exceed reasonable limits, we will charge a certain cost fee based on the circumstances. We may reject
            requests that are unreasonably repetitive, require disproportionate technical effort (e.g., developing new
            systems or fundamentally changing current practices), risk the legitimate rights and interests of others, or
            are
            highly impractical (e.g., involving information stored on backup tapes). Under the following circumstances,
            in
            accordance with laws and regulations, we will not be able to respond to your request:</p>
          <p>(1) Directly related to national security or defense security;</p>
          <p>(2) Directly related to public safety, public health, or major public interests;</p>
          <p>(3) Directly related to criminal investigation, prosecution, trial, and enforcement of judgments;</p>
          <p>(4) There is sufficient evidence to show that you have subjective malice or abuse of rights;</p>
          <p>(5) Responding to your request would cause serious harm to the legitimate rights and interests of you or
            other
            individuals or organizations;</p>
          <p>(6) Involves trade secrets.</p>

          <h3>VI. How We Use Cookies and Similar Technologies</h3>
          <p>6.1 To ensure the normal operation of the website, we will store small data files called cookies on your
            computer or mobile device. Cookies usually contain an identifier, site name, and some numbers and
            characters.
            The Clinical Trial Cloud Platform can only read cookies provided by the Clinical Trial Cloud Platform. You
            agree
            that we have the right to collect your usage and behavior information through cookie technology, and freely
            use
            the de-identified pure commercial data after anonymizing it so that it no longer points to or is associated
            with
            your personal identity.</p>
          <p>6.2 You can manage cookies according to your preferences, and you can also clear all cookies stored on your
            computer. Most web browsers have a feature to block cookies. However, if you do so, you will need to change
            your
            user settings each time you visit our website. For detailed information on how to change browser settings,
            please visit the relevant settings page of the browser you are using.</p>

          <h3>VII. How We Protect and Store Your User Information</h3>
          <p>7.1 The Clinical Trial Cloud Platform attaches great importance to your information security. We strive to
            adopt various reasonable physical, electronic, and management security measures to protect your user
            information
            from unauthorized access, public disclosure, use, modification, damage, or loss. We use encryption
            technology to
            enhance the security of user information; we use trusted protection mechanisms to prevent user information
            from
            malicious attacks; we deploy access control mechanisms to ensure that only authorized personnel can access
            user
            information; and we conduct security and privacy protection training courses to enhance employees' awareness
            of
            the importance of protecting user information.</p>
          <p>7.2 We have obtained the following certifications: ISO/IEC 27001 International Information Security
            Management
            System Certification, ISO/IEC 27701 International Privacy Information Management System Certification,
            ISO/IEC
            27017 Cloud Service Information Security Management System Certification, and ISO/IEC 27018 Public Cloud
            Personally Identifiable Information Management System Certification.
          </p>
          <p>7.3 We will take reasonable and feasible measures to avoid collecting irrelevant user information. We will
            only
            retain your user information for the period necessary to achieve the purposes described in this policy,
            unless
            permitted by law. After the above user information retention period expires, we will delete or anonymize
            your
            personal information.
          </p>
          <p>7.4 Please use complex passwords to help us ensure the security of your account. We will do our best to
            ensure
            the security of any information you send to us. If our physical, technical, or management protective
            facilities
            are damaged, resulting in unauthorized access, public disclosure, tampering, or destruction of information,
            causing damage to your legitimate rights and interests, we will bear corresponding legal liability.
          </p>
          <p>7.5 In the unfortunate event of a user information security incident (leakage, loss, etc.), we will
            promptly
            notify you in accordance with legal requirements: the basic circumstances and possible impact of the
            security
            incident, the disposal measures we have taken or will take, suggestions for you to independently prevent and
            reduce risks, and remedial measures for you. We will promptly notify you of the incident by email, letter,
            phone, push notification, etc. If it is difficult to notify each user information subject individually, we
            will
            issue a public announcement in a reasonable and effective manner.
          </p>
          <p>7.6 At the same time, we will also report the handling of user information security incidents to regulatory
            authorities as required.
          </p>
          <p>7.7 The user information we collect from you is stored within the territory of the People's Republic of
            China.
            If business needs require transferring personal information overseas under circumstances that comply with
            applicable laws, we will obtain your prior consent and inform you of the purpose of the transfer, the
            recipient,
            security measures, security risks, etc.
          </p>
          <p>7.8 In the event that the Clinical Trial Cloud Platform products and services cease operation, we will take
            reasonable measures to protect the security of your user information, including promptly ceasing the
            activity of
            collecting user information; notifying users of the cessation of operations by individual notice or public
            announcement; and deleting or anonymizing the personal information we hold.
          </p>

          <h3>VIII. Special Provisions for Minor User Information</h3>
          <p>8.1 We primarily provide products and services to adults. If you are a minor, please do not use our
            products
            and services in any form, nor provide us with your personal information in any form.</p>
          <p>8.2 Please be aware and understand that due to existing technology and business models, we may
            unintentionally
            collect personal information of minors. If you are a guardian of a minor and you discover that we have
            obtained
            the minor's personal information without your authorization, you may contact us through the contact
            information
            provided in this policy. Upon receiving the notice, we will promptly verify the matter and, after
            confirmation,
            delete or anonymize the relevant information. If we proactively discover such a situation through our own
            review, we will also proactively delete or anonymize the relevant personal information.</p>

          <h3>IX. Updates to the Privacy Policy</h3>
          <p>9.1 Our Privacy Policy may be revised.</p>
          <p>9.2 Without your explicit consent, we will not restrict the rights you should enjoy under this Privacy
            Policy.
            We will publish any revisions to the Privacy Policy on a dedicated page.</p>
          <p>9.3 For major changes, we will inform you of the specific changes to the Privacy Policy by pop-up
            notification.
          </p>
          <p>9.4 Major changes referred to in this policy include but are not limited to:</p>
          <p>9.4.1 Major changes in our service model, such as the purpose of processing user information, the type of
            user
            information processed, the way user information is used, etc.;</p>
          <p>9.4.2 Major changes in our control or organizational structure, such as ownership changes due to business
            adjustments, bankruptcy mergers, etc.;</p>
          <p>9.4.3 Major changes in the main parties with whom user information is shared, transferred, or publicly
            disclosed;</p>
          <p>9.4.4 Major changes in your rights regarding the processing of user information and the way you exercise
            them;
          </p>
          <p>9.4.5 Changes in the responsible department, contact information, and complaint channels for processing
            user
            information security;</p>
          <p>9.4.6 When the user information security impact assessment report indicates a high risk.</p>

          <h3>X. How to Contact Us</h3>
          <p>If you have any questions or comments about the content of this statement and policy, or if you have any
            questions or comments about the practices or operations of the Clinical Trial Cloud Platform or this Privacy
            Policy, please contact us by calling customer service (010-85591162) or by email (yuan.lu@panacro.com). If
            you
            have any questions or need to file a complaint regarding personal privacy protection or other
            security-related
            issues, you can contact us via the company's information security email: helpdesk@panacro.com. After
            verifying
            your identity, we will respond to you within 15 working days.</p>
          <p>If you are not satisfied with our response, or if our handling of your personal information infringes upon
            your
            legitimate rights and interests, and we still refuse to improve after you provide feedback to us, you may
            file a
            complaint or report with regulatory authorities such as public security or cybersecurity authorities, or
            file a
            lawsuit in a competent court.</p>
        </div>
      </div>
    </a-modal>

    <a-modal v-model:visible="userAgreementVisible" :title="t('login.platformUserAgreement')" :footer="null"
      :width="860" centered :bodyStyle="{ height: '70vh', overflowY: 'hidden' }">
      <div class="privacy-html">
        <div style="padding-bottom: 50px;" v-if="locale == 'zh-CN'">
          <h2 style="text-align: center;">临床试验云平台用户协议</h2>
          <p><strong>本协议的更新日期：2026年1月15日</strong></p>
          <p><strong>本协议的生效日期：2026年1月15日</strong></p>

          <h3>提示条款</h3>
          <p>欢迎您参与签署《临床试验云平台用户协议》（下称"本协议"）并使用云平台服务！</p>
          <p>自本协议发布之日起，各处所称"临床试验云平台用户协议"均指本协议。</p>
          <p>各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。</p>
          <p>
            <strong>审慎阅读：</strong>临床试验云平台用户通过企业发送的邀请链接设置密码完成账户注册，同时系统自动同步钉钉通讯录信息实现账户开通，用户需在登录和使用时确认授权协议。当您在登录和使用临床试验云平台时，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对本协议有任何疑问，可向临床试验云平台客服咨询。
          </p>
          <p>
            <strong>签约动作：</strong>当您通过企业邀请链接或钉钉通讯录同步完成身份验证后，系统将引导您至协议确认页面，提示阅读并同意本协议后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我们达成一致，成为临床试验云平台"用户"。阅读本协议的过程中，如果您不同意本协议任何条款约定，请立即停止使用服务并关闭页面。
          </p>

          <h3>一、定义</h3>
          <p>1.1我们：指临床试验云平台的所有者、经营者，博纳西亚（杭州）医药科技有限公司。</p>

          <h3>二、协议范围</h3>
          <p><strong>2.1 签约主体</strong></p>
          <p>本协议由您与我们共同缔结，本协议对您与我们均具有法律效力。</p>
          <p><strong>2.2协议内容</strong></p>
          <p>
            本协议内容包括：本协议正文、临床试验云平台《隐私政策》、临床试验云平台规则（指您在使用临床试验云平台某一特定服务时，该服务可能会另有单独的协议、相关业务规则等）及其修订版本。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对临床试验云平台《隐私政策》的接受。
          </p>

          <h3>三、账户开通与使用</h3>
          <p><strong>3.1 用户资格</strong></p>
          <p>
            您确认，在您明确"账户开通"和使用临床试验云平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，请确保您在监护人监护、指导下阅读本协议并征得您的监护人同意，在此情况下，您及您的监护人应依照法律规定承担因此而导致的一切后果。
          </p>
          <p>此外，您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用临床试验云平台服务。</p>
          <p><strong>3.2 账户说明</strong></p>
          <p><strong>3.2.1账户获得</strong></p>
          <p>当您通过企业邀请链接或钉钉通讯录同步完成身份验证后，系统将引导您至协议确认页面。阅读并同意本协议的全部内容，即表示您已完成账户开通，成为临床试验云平台用户并使用该账户。</p>
          <p>
            <strong>3.2.2</strong>临床试验云平台只允许每位用户同一个账号只能绑定一个手机号或邮箱。如有证据证明或我们根据临床试验云平台规则判断您存在钉钉通讯录1个手机号绑定多个账号情形，临床试验云平台可采取冻结或关闭账户、拒绝提供服务等措施，如给临床试验云平台及相关方造成损失的，您还应承担赔偿责任。
          </p>
          <p><strong>3.3 账户信息管理</strong></p>
          <p><strong>3.3.1 真实合法</strong></p>
          <p>您了解并同意，您有义务保证您提供信息的真实性、合法性及有效性。您设置的临床试验云平台用户名不得违反国家法律法规，否则我们可回收您的临床试验云平台用户名。</p>
          <p><strong>3.3.2 更新维护</strong></p>
          <p>您应当及时更新您提供的信息，在法律有明确规定要求我们作为服务提供者必须对部分用户的信息进行核实的情况下，我们将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。</p>
          <p>
            如我们按您最后一次提供的信息与您联系未果、您未按我们的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此导致的不利后果。我们可向您发出询问或要求整改的通知，并要求您进行重新认证，甚至中止、终止对您提供部分或全部临床试验云平台服务，我们对此不承担责任。
          </p>
          <p><strong>3.4 账户安全规范</strong></p>
          <p><strong>3.4.1账户安全保管义务</strong></p>
          <p>您的账户为您自行设置并由您保管，我们任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开临床试验云平台。</p>
          <p>因您主动泄露账户或遭受诈骗等行为导致您的损失及后果，我们对此不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</p>
          <p><strong>3.4.2账户行为责任自负</strong></p>
          <p>除我们存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、服务及披露信息等）负责。</p>
          <p><strong>3.4.3日常维护须知</strong></p>
          <p>
            如发现任何未经授权使用您账户登录临床试验云平台或其他可能导致您账户遭窃、遗失的情况，您应立即通知我们。您理解我们对您的任何请求采取行动均需要合理时间，且我们应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除我们存在法定过错外，我们不承担责任。
          </p>

          <h3>四、用户行为规范</h3>
          <p><strong>4.1 用户行为要求</strong></p>
          <p>您应当对您使用本产品及相关服务的行为负责，除非法律允许或者经我们事先书面许可，您使用临床试验云平台及相关服务不得具有下列行为：</p>
          <p><strong>4.1.1</strong> 使用未经我们授权或许可的任何插件、外挂、系统或第三方工具对临床试验云平台及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
          <p><strong>4.1.2</strong> 利用或针对临床试验云平台及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
          <p>（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</p>
          <p>（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</p>
          <p>（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</p>
          <p>（4）使用未经许可的数据或进入未经许可的服务器/账号；</p>
          <p>（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>
          <p>（6）未经许可，企图探查、扫描、测试临床试验云平台系统的弱点或其它实施破坏网络安全的行为；</p>
          <p>（7）企图干涉、破坏临床试验云平台系统的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</p>
          <p>（8）伪造TCP/IP数据包名称或部分名称。</p>
          <p>（9）对临床试验云平台进行反向工程、反向汇编、编译或者以其他方式尝试发现本软件的源代码。</p>
          <p>（10）违反法律法规、本协议、我们的相关规则及侵犯他人合法权益的其他行为。</p>
          <p>
            <strong>4.2</strong>如果我们发现或收到他人举报或投诉用户违反本协议约定的，我们有权不经通知随时对举报和投诉的内容，包括但不限于用户资料、聊天记录进行审查、删除，并视情节轻重对违规帐号采取包括但不限于警告、帐号封禁
            、设备封禁 、功能封禁的措施，且通知用户处理结果。
          </p>
          <p><strong>4.3</strong>因违反本协议被封禁的用户，可向我们发送邮件进行申诉。我们将对申诉进行审查，并自行合理判断决定是否变更相应措施。</p>

          <h3>五、用户信息的保护及授权</h3>
          <p><strong>5.1个人信息的保护</strong></p>
          <p>我们非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用我们提供的服务时，您同意我们按照在临床试验云平台上公布的《隐私政策》收集、存储、使用、披露和保护您的个人信息。</p>
          <p><strong>5.2非个人信息的保证</strong></p>
          <p><strong>5.2.1信息的发布</strong></p>
          <p>您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，我们可对您发布的信息依法或依本协议进行删除或屏蔽。</p>
          <p><strong>5.2.2禁止性信息</strong></p>
          <p>您应当确保您所发布的信息不包含以下内容：</p>
          <p>（1）违反国家法律法规禁止性规定的；</p>
          <p>（2）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
          <p>（3）欺诈、虚假、不准确或存在误导性的；</p>
          <p>（4）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</p>
          <p>（5）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</p>
          <p>（6）存在可能破坏、篡改、删除、影响临床试验云平台任何系统正常运行或未经授权秘密获取临床试验云平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</p>
          <p>（7）其他违背社会公共利益或公共道德或依据相关临床试验云平台协议、规则的规定不适合在临床试验云平台上发布的。</p>

          <h3>六、协议的终止</h3>
          <p><strong>6.1 终止的情形</strong></p>
          <p><strong>6.1.1</strong>您有权通过以下任一方式终止本协议：</p>
          <p>（1）变更事项生效前您停止使用并明示不愿接受变更事项的；</p>
          <p>（2）您明示不愿继续使用临床试验云平台服务；</p>
          <p><strong>6.2.2</strong>出现以下情况时，我们可以通知您终止本协议：</p>
          <p>（1）您违反本协议约定，我们依据违约条款终止本协议的；</p>
          <p>（2）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，我们依据临床试验云平台规则对您的账户予以查封的；</p>
          <p>（3）除上述情形外，因您多次违反临床试验云平台规则相关规定且情节严重，我们依据临床试验云平台规则对您的账户予以查封的；</p>
          <p>（4）您的账户被我们依据本协议回收的；</p>
          <p>（5）其它应当终止服务的情况。</p>
          <p><strong>6.2 协议终止后的处理</strong></p>
          <p>本协议终止后，我们仍享有下列权利：</p>
          <p><strong>6.2.1</strong>对于您过往的违约行为，我们仍可依据本协议向您追究违约责任。</p>
          <p><strong>6.2.2</strong>我们有权依据合理判断对您违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存向有关部门报告的信息，您应独自承担由此而产生的一切法律责任。</p>

          <h3>七、不可抗力或其他免责事由</h3>
          <p><strong>7.1不可抗力</strong></p>
          <p>
            您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务协议下的服务发生中断或终止。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、法律法规变动、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务等行为。出现上述情况时，我们将努力在第一时间与相关部门配合，及时进行修复，但是由此给您造成的损失，我们在法律允许的范围内免责。
          </p>
          <p><strong>7.2其他免责事由</strong></p>
          <p>您理解并同意，在法律允许的范围内，我们对以下事由所导致的服务中断或终止不承担责任：</p>
          <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
          <p>（2）用户或我们的电脑软件、系统、硬件和通信线路出现故障；</p>
          <p>（3）用户操作不当；</p>
          <p>（4）用户通过非我们授权的方式使用本服务；</p>
          <p>（5）其他我们无法控制或合理预见的情形。</p>

          <h3>八、法律声明</h3>
          <p><strong>8.1权利归属</strong></p>
          <p>
            除非临床试验云平台另行声明，临床试验云平台推出的所有官方产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计等）的所有权利（包括但不限于著作权、商标权、专利权、商业秘密及其他相关权利）均归我们及其关联公司所有。未经我们及或其关联公司事先书面许可，任何人擅自使用上述内容和信息，可能会侵犯我们及/或其关联公司的权利，我公司将会追究侵权者的法律责任。如有宣传、展示等任何使用需要，您务必取得我们及/或其关联公司的事先书面许可。
          </p>
          <p>
            <strong>8.2</strong>我们尊重知识产权，反对并打击侵犯知识产权的行为。知识产权权利人若认为临床试验云平台内容侵犯其合法权益的，可以通过拨打客服电话010-8559116或通过邮件helpdesk@panacro.com进行投诉，我们将在收到知识产权权利人合格通知后依据相应的法律法规及时处理。
          </p>

          <h3>九、法律适用、管辖与其他</h3>
          <p><strong>9.1法律适用</strong></p>
          <p>本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p>
          <p><strong>9.2管辖</strong></p>
          <p>您因使用临床试验云平台服务所产生及与临床试验云平台服务有关的争议，由我们与您协商解决。协商不成时，任何一方均可向有管辖权的法院提起诉讼。</p>
          <p><strong>9.3语言版本</strong></p>
          <p>若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。</p>
          <p><strong>9.4可分性</strong></p>
          <p>本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
          <p><strong>9.5如何联系我们</strong></p>
          <p>
            您对本协议内容有任何疑问和意见，或者您对临床试验云平台实践以及操作上有任何疑问和意见，请拨打客服电话（010-85591162）或通过邮件（helpdesk@panacro.com）与我们联系，我们将在确认您的身份后，在15个工作日内给您答复。
          </p>
        </div>
        <div style="padding-bottom: 50px;" v-else>
          <h2 style="text-align: center;">Clinical Trial Cloud Platform User Agreement</h2>
          <p><strong>Update Date of this Agreement: January 15, 2026</strong></p>
          <p><strong>Effective Date of this Agreement: January 15, 2026</strong></p>

          <h3>Important Notice</h3>
          <p>Welcome to enter into the Clinical Trial Cloud Platform User Agreement (hereinafter referred to as "this
            Agreement") and use the Cloud Platform Services!</p>
          <p>From the date of publication of this Agreement, all references to the "Clinical Trial Cloud Platform User
            Agreement" shall refer to this Agreement.</p>
          <p>The index keywords listed before each service clause are only intended to help you understand the gist of
            such
            clause and shall not affect or limit the meaning or interpretation of the terms of this Agreement. To
            protect
            your own rights and interests, you are advised to carefully read the specific wording of each clause.</p>
          <p><strong>Careful Reading: </strong>Users of the Clinical Trial Cloud Platform complete account registration
            by
            setting a password via an invitation link sent by the enterprise, while the system automatically
            synchronizes
            DingTalk contact information to activate the account. You need to confirm the authorization agreement when
            logging in and using the platform. When you log in and use the Clinical Trial Cloud Platform, you should
            carefully read this Agreement. You must carefully read and fully understand the contents of each clause, in
            particular the clauses that exempt or limit liability, the governing law and dispute resolution clauses.
            Clauses
            that exempt or limit liability will be identified by bold underlined text, and you should read them
            carefully.
            If you have any questions about this Agreement, you may consult the Clinical Trial Cloud Platform customer
            service.</p>
          <p><strong>Act of Acceptance: </strong>When you complete identity verification through an enterprise
            invitation
            link or DingTalk contact synchronization, the system will direct you to the agreement confirmation page.
            After
            you are prompted to read and agree to this Agreement, that means you have fully read, understood and
            accepted
            all the contents of this Agreement, and have reached an agreement with us, becoming a "User" of the Clinical
            Trial Cloud Platform. During the process of reading this Agreement, if you do not agree to any term of this
            Agreement, please immediately stop using the service and close the page.</p>

          <h3>I. Definitions</h3>
          <p>1.1 "We", "Us", "Our": means the owner and operator of the Clinical Trial Cloud Platform, Bonasia
            (Hangzhou)
            Pharmaceutical Technology Co., Ltd.</p>

          <h3>II. Scope of Agreement</h3>
          <p><strong>2.1 Contracting Parties</strong></p>
          <p>This Agreement is entered into between you and us, and is legally binding on both you and us.</p>
          <p><strong>2.2 Content of Agreement</strong></p>
          <p>The content of this Agreement includes: the body of this Agreement, the Privacy Policy of the Clinical
            Trial
            Cloud Platform, the Clinical Trial Cloud Platform rules (meaning that when you use a specific service of the
            Clinical Trial Cloud Platform, such service may be subject to a separate agreement, relevant business rules,
            etc.) and their amendments. Once formally published, the foregoing content shall become an integral part of
            this
            Agreement, and you shall also comply with them. Your acceptance of any separate agreement mentioned above
            shall
            be deemed as your acceptance of this Agreement in its entirety. Your acceptance of this Agreement shall be
            deemed as your acceptance of the Privacy Policy of the Clinical Trial Cloud Platform.</p>

          <h3>III. Account Activation and Use</h3>
          <p><strong>3.1 User Eligibility</strong></p>
          <p>You acknowledge that before you expressly activate an account and use the Clinical Trial Cloud Platform
            services, you must have the civil capacity to act in accordance with the laws of the People's Republic of
            China.
            If you do not have such civil capacity, you must ensure that you read this Agreement under the supervision
            and
            guidance of your guardian and obtain your guardian's consent. In such case, you and your guardian shall bear
            all
            consequences arising therefrom in accordance with applicable laws.</p>
          <p>In addition, you must also ensure that you are not a target of trade restrictions, sanctions, or other
            legal or
            regulatory restrictions imposed by any country, international organization, or region; otherwise, you may
            not be
            able to register and use the Clinical Trial Cloud Platform services normally.</p>
          <p><strong>3.2 Account Description</strong></p>
          <p><strong>3.2.1 Account Acquisition</strong></p>
          <p>When you complete identity verification through an enterprise invitation link or DingTalk contact
            synchronization, the system will direct you to the agreement confirmation page. Reading and agreeing to all
            the
            contents of this Agreement means that you have completed account activation, become a user of the Clinical
            Trial
            Cloud Platform, and may use that account.</p>
          <p><strong>3.2.2</strong>The Clinical Trial Cloud Platform only allows each user to bind one mobile number or
            one
            email address to the same account. If there is evidence, or if we determine based on Clinical Trial Cloud
            Platform rules, that you have bound multiple accounts to one mobile number in DingTalk contacts, the
            Clinical
            Trial Cloud Platform may take measures such as freezing or closing the account, refusing to provide
            services,
            etc. If such action causes losses to the Clinical Trial Cloud Platform or relevant parties, you shall also
            be
            liable for compensation.</p>
          <p><strong>3.3 Account Information Management</strong></p>
          <p><strong>3.3.1 Truthfulness and Lawfulness</strong></p>
          <p>You understand and agree that you are obliged to ensure the truthfulness, lawfulness and validity of the
            information you provide. The username you set for the Clinical Trial Cloud Platform must not violate
            national
            laws and regulations; otherwise, we may reclaim your Clinical Trial Cloud Platform username.</p>
          <p><strong>3.3.2 Update and Maintenance</strong></p>
          <p>You shall promptly update the information you provide. Where laws or regulations explicitly require us, as
            the
            service provider, to verify the information of certain users, we will from time to time check and verify
            your
            information in accordance with the law, and you shall cooperate by providing the latest, true, complete, and
            valid information.</p>
          <p>If we fail to contact you using the information you last provided, if you fail to provide information
            promptly
            as requested by us, if the information you provide is obviously false, or if administrative or judicial
            authorities verify that the information you provided is invalid, you shall bear any adverse consequences
            arising
            therefrom. We may send you inquiries or require you to rectify, request you to re-authenticate, or even
            suspend
            or terminate the provision of some or all Clinical Trial Cloud Platform services to you, and we shall not be
            held liable for such actions.</p>
          <p><strong>3.4 Account Security Obligations</strong></p>
          <p><strong>3.4.1 Obligation to Safely Keep Your Account</strong></p>
          <p>Your account is set up and maintained by you. We will never proactively ask you for your account password.
            Therefore, it is recommended that you take good care of your account and ensure that you log out at the end
            of
            each online session and leave the Clinical Trial Cloud Platform following the correct procedure.</p>
          <p>We shall not be liable for any losses or consequences resulting from your active disclosure of your account
            or
            from fraud. You shall seek recourse from the infringing party through judicial or administrative remedies.
          </p>
          <p><strong>3.4.2 Responsibility for Account Actions</strong></p>
          <p>Except for our fault, you shall be responsible for all actions and results under your account (including
            but
            not limited to online signing of various agreements, publishing information, services, and disclosing
            information).</p>
          <p><strong>3.4.3 Daily Maintenance Notice</strong></p>
          <p>If you discover any unauthorized use of your account to log in to the Clinical Trial Cloud Platform or any
            other situation that may lead to theft or loss of your account, you shall immediately notify us. You
            understand
            that it takes a reasonable amount of time for us to take action in response to your request, and that
            actions
            taken by us at your request may not avoid or prevent the formation or expansion of the consequences of
            infringement. Except for our statutory fault, we shall not be liable.</p>

          <h3>IV. User Code of Conduct</h3>
          <p><strong>4.1 User Conduct Requirements</strong></p>
          <p>You shall be responsible for your use of this product and related services. Unless permitted by law or with
            our
            prior written consent, you shall not engage in the following conduct when using the Clinical Trial Cloud
            Platform and related services:</p>
          <p><strong>4.1.1</strong> 4.1.1 Use any plug-ins, add-ons, systems, or third-party tools not authorized or
            permitted by us to interfere with, disrupt, modify, or otherwise affect the normal operation of the Clinical
            Trial Cloud Platform and related services.</p>
          <p><strong>4.1.2</strong> 4.1.2 Engage in any activity that compromises computer network security using or
            targeting the Clinical Trial Cloud Platform and related services, including but not limited to:</p>
          <p>(1) Illegally intruding into others' networks, interfering with the normal functions of others' networks,
            stealing network data, or other activities that endanger network security;</p>
          <p>(2) Providing programs or tools specifically designed to engage in activities that endanger network
            security,
            such as intruding into networks, interfering with normal network functions and protective measures, or
            stealing
            network data;</p>
          <p>(3) Providing technical support, advertising promotion, payment settlement, or other assistance to persons
            known to be engaged in activities endangering network security;</p>
          <p>(4) Using unauthorized data or accessing unauthorized servers/accounts;</p>
          <p>(5) Deleting, modifying, or adding stored information without authorization after entering a public
            computer
            network or another person's computer system;</p>
          <p>(6) Attempting to probe, scan, or test the vulnerabilities of the Clinical Trial Cloud Platform system or
            otherwise undermining network security;</p>
          <p>(7) Attempting to interfere with or disrupt the normal operation of the Clinical Trial Cloud Platform
            system,
            intentionally spreading malicious programs or viruses, or other acts that undermine or interfere with normal
            network information services;</p>
          <p>(8) Forging TCP/IP packet names or partial names;</p>
          <p>(9) Reverse engineering, reverse assembling, compiling, or otherwise attempting to discover the source code
            of
            the software;</p>
          <p>(10) Violating laws or regulations, this Agreement, our relevant rules, or otherwise infringing the lawful
            rights and interests of others.</p>
          <p><strong>4.2</strong>If we discover or receive a report or complaint from others that a user violates this
            Agreement, we have the right, without prior notice, to review and delete the content of the report or
            complaint,
            including but not limited to user profiles and chat records, and to take measures against the violating
            account
            depending on the severity of the violation, including but not limited to warnings, account suspension,
            device
            blocking, function blocking, and notify the user of the outcome.</p>
          <p><strong>4.3</strong>Users blocked for violating this Agreement may send an email to us to appeal. We will
            review the appeal and, at our reasonable discretion, decide whether to change the corresponding measures.
          </p>

          <h3>V. Protection and Authorization of User Information</h3>
          <p><strong>5.1 Protection of Personal Information</strong></p>
          <p>We attach great importance to the protection of users' personal information (i.e., information that can
            identify a user, either alone or in combination with other information). When you use the services we
            provide,
            you agree that we will collect, store, use, disclose, and protect your personal information in accordance
            with
            the Privacy Policy published on the Clinical Trial Cloud Platform.</p>
          <p><strong>5.2 Assurance Regarding Non-Personal Information</strong></p>
          <p><strong>5.2.1 Information Publication</strong></p>
          <p>You represent and warrant that you have appropriate and lawful rights to the information you publish.
            Otherwise, we may delete or block the information you publish in accordance with the law or this Agreement.
          </p>
          <p><strong>5.2.2 Prohibited Information</strong></p>
          <p>You shall ensure that the information you publish does not contain the following:</p>
          <p>(1) Content that violates prohibitive provisions of national laws and regulations;</p>
          <p>(2) Political propaganda, feudal superstition, obscenity, pornography, gambling, violence, terrorism, or
            incitement to crime;</p>
          <p>(3) Fraudulent, false, inaccurate, or misleading content;</p>
          <p>(4) Content that infringes others' intellectual property rights or involves third-party trade secrets or
            other
            proprietary rights;</p>
          <p>(5) Content that insults, defames, intimidates, invades others' privacy, or otherwise infringes upon the
            lawful
            rights and interests of others;</p>
          <p>(6) Malicious software, program codes such as viruses, Trojans, web crawlers, etc., that may damage, tamper
            with, delete, affect the normal operation of any system of the Clinical Trial Cloud Platform, or secretly
            obtain
            data or personal information of the Clinical Trial Cloud Platform or other users</p>
          <p>(7) Other content that violates public interests or moral standards, or that is unsuitable for publication
            on
            the Clinical Trial Cloud Platform according to relevant agreements or rules of the Clinical Trial Cloud
            Platform.</p>

          <h3>VI. Termination of the Agreement</h3>
          <p><strong>6.1 Circumstances of Termination</strong></p>
          <p><strong>6.1.1</strong>You have the right to terminate this Agreement by any of the following means:</p>
          <p>(1) Before a change becomes effective, you stop using the service and expressly state that you do not
            accept
            the change;</p>
          <p>(2) You expressly state that you no longer wish to use the Clinical Trial Cloud Platform services.</p>
          <p><strong>6.2.2</strong>6.2.2 This Agreement may be terminated by us with notice to you under the following
            circumstances:</p>
          <p>(1) You violate this Agreement, and we terminate this Agreement pursuant to the breach provisions;</p>
          <p>(2) You steal others' accounts, post prohibited information, defraud others of property, sell counterfeit
            goods, disrupt market order, or engage in improper means for profit, and we freeze your account in
            accordance
            with Clinical Trial Cloud Platform rules;</p>
          <p>(3) In addition to the above circumstances, if you repeatedly violate the relevant rules of the Clinical
            Trial
            Cloud Platform and the circumstances are serious, and we freeze your account in accordance with Clinical
            Trial
            Cloud Platform rules;</p>
          <p>(4) Your account is recovered by us in accordance with this Agreement;</p>
          <p>(5) Other circumstances where the service should be terminated.</p>
          <p><strong>6.2 Consequences after Termination</strong></p>
          <p>After termination of this Agreement, we still have the following rights:</p>
          <p><strong>6.2.1</strong>We may still pursue your liability for past breaches of this Agreement in accordance
            with
            this Agreement.</p>
          <p><strong>6.2.2</strong>We have the right to take appropriate legal action against your conduct that violates
            applicable laws or regulations or this Agreement, based on reasonable judgment, and to report relevant
            information to competent authorities in accordance with laws and regulations. You shall bear all legal
            liability
            arising therefrom.</p>

          <h3>VII. Force Majeure or Other Exemption Clauses</h3>
          <p><strong>7.1 Force Majeure</strong></p>
          <p>You understand and agree that during the use of this service, you may encounter force majeure or other risk
            factors that may cause interruption or termination of services under this Agreement. Force majeure means
            objective events that cannot be foreseen, overcome, or avoided and that have a material impact on one or
            both
            parties, including but not limited to information network equipment maintenance, information network
            connection
            failures, computer, communication or other system failures, power failures, strikes, labor disputes, riots,
            uprisings, civil disturbances, productivity or material shortages, fires, floods, storms, explosions, war,
            governmental actions, changes in laws and regulations, orders of judicial or administrative authorities,
            other
            force majeure events, or inaction of third parties that result in service unavailability or delay. In the
            event
            of the above, we will strive to cooperate with relevant authorities to promptly remedy the situation.
            However,
            to the extent permitted by law, we shall not be liable for any loss caused to you thereby.</p>
          <p><strong>7.2 Other Exemption Clauses</strong></p>
          <p>You understand and agree that, to the extent permitted by law, we shall not be liable for service
            interruption
            or termination caused by:</p>
          <p>(1) Destruction by computer viruses, Trojans or other malicious programs, or hacker attacks;</p>
          <p>(2) Malfunctions in computer software, systems, hardware, or communication lines of you or us;</p>
          <p>(3) Improper operation by you</p>
          <p>(4) Your use of this service through means not authorized by us;</p>
          <p>(5) Other circumstances beyond our control or reasonably foreseeable.</p>

          <h3>VIII. Legal Statement</h3>
          <p><strong>8.1 Ownership of Rights</strong></p>
          <p>Unless otherwise stated by the Clinical Trial Cloud Platform, all rights (including but not limited to
            copyright, trademark rights, patent rights, trade secrets, and other related rights) in all official
            products,
            technologies, software, programs, data, and other information (including but not limited to text, icons,
            images,
            photos, audio, video, charts, color combinations, layout designs, etc.) launched by the Clinical Trial Cloud
            Platform are owned by us and our affiliates. Without our prior written permission or that of our affiliates,
            any
            unauthorized use of the above content and information may infringe the rights of us and/or our affiliates,
            and
            our company will pursue legal liability against the infringer. If you need to use such content for
            publicity,
            display, or any other purpose, you must obtain our prior written permission or that of our affiliates.</p>
          <p><strong>8.2</strong>We respect intellectual property rights and oppose and combat intellectual property
            infringement. If an intellectual property right holder believes that the content on the Clinical Trial Cloud
            Platform infringes its legal rights, it may file a complaint by calling customer service at 010-8559116 or
            by
            emailing helpdesk@panacro.com. Upon receipt of a qualified notice from the intellectual property right
            holder,
            we will handle it promptly in accordance with applicable laws and regulations.</p>

          <h3>X. Governing Law, Jurisdiction, and Miscellaneous</h3>
          <p><strong>9.1 Governing Law</strong></p>
          <p>The formation, effectiveness, interpretation, amendment, supplementation, termination, execution, and
            dispute
            resolution of this Agreement shall be governed by the laws of the mainland region of the People's Republic
            of
            China. If no relevant laws exist, reference shall be made to commercial practices and/or industry practices.
          </p>
          <p><strong>9.2 Jurisdiction</strong></p>
          <p>Any dispute arising from your use of the Clinical Trial Cloud Platform services or relating to the Clinical
            Trial Cloud Platform services shall be resolved through negotiation between us and you. If negotiation
            fails,
            either party may bring a lawsuit in a court of competent jurisdiction.</p>
          <p><strong>9.3 Language Version</strong></p>
          <p>If this Agreement is available in multiple language versions, such as Chinese and English, and there are
            inconsistencies, the Chinese version shall prevail.</p>
          <p><strong>9.4 Severability</strong></p>
          <p>If any provision of this Agreement is deemed invalid, void, or unenforceable, such provision shall be
            deemed
            severable and shall not affect the validity and enforceability of the remaining provisions of this
            Agreement.
          </p>
          <p><strong>9.5 How to Contact Us</strong></p>
          <p>If you have any questions or comments regarding the content of this Agreement, or if you have any questions
            or
            comments regarding the practices or operations of the Clinical Trial Cloud Platform, please contact us by
            calling customer service (010-85591162) or by email (helpdesk@panacro.com). After verifying your identity,
            we
            will respond to you within 15 working days.</p>
        </div>
      </div>
    </a-modal>

    <a-modal v-model:visible="tipModalVisible" :title="t('login.tip')" @ok="handleAgreeInTip"
      :okText="t('login.aggreStr1')" :cancelText="t('login.disagree')" :width="600" centered>
      <div class="tip-modal-content">
        <p>
          {{ t('login.agreeStr4') }}
          <a class="tip-agreement-link" @click.stop="openUserAgreement">《{{ t('login.userAgreement') }}》</a>
          {{ t('login.aggreStr2') }}
          <a class="tip-agreement-link" @click.stop="openPrivacy">《{{ t('login.privacyPolicy') }}》</a>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted, reactive } from "vue";
import loginComponent from "@/components/login_component.vue";
import loginUser from "@/components/login_user.vue";
import loginPhone from "@/components/login_phone.vue";
import verifyEmail from "@/components/verify_email.vue";
import { useStore } from "vuex";
import { login, verifyAccountSecret, checkEmailCode } from "@/utils/api";
import {
  encryrt,
  getVisibility,
  getVisibilityState,
  getCookie,
} from "@/utils/common";
import { message } from "ant-design-vue";
import LanguageSwitch from '@/components/Language_switch.vue'
import { useI18n } from 'vue-i18n'
type VerifyProp = {
  email?: string;
  params?: any;
  [key: string]: any;
};
export default defineComponent({
  components: { loginComponent, loginUser, loginPhone, verifyEmail, LanguageSwitch },
  setup() {
    const { t, locale } = useI18n()
    const store = useStore();
    const loginAll = ref();
    const loginUser = ref();
    const loginPhone = ref();
    const loginVerifyEmail = ref();
    const showVerify = ref<true | false>(false);
    const verifyProp = ref<VerifyProp>({});

    const agreedToTerms = ref(false);
    const privacyVisible = ref(false);
    const userAgreementVisible = ref(false);
    const tipModalVisible = ref(false);
    const pendingLoginType = ref<string | null>(null);

    const openPrivacy = () => {
      privacyVisible.value = true;
      tipModalVisible.value = false;
    };

    const openUserAgreement = () => {
      userAgreementVisible.value = true;
      tipModalVisible.value = false;
    };

    const handleAgreeInTip = () => {
      agreedToTerms.value = true;
      tipModalVisible.value = false;
      // 如果有待执行的登录类型，自动执行登录
      if (pendingLoginType.value) {
        const type = pendingLoginType.value;
        pendingLoginType.value = null;
        executeLogin(type);
      }
    };

    // 检查表单是否已填写
    const checkFormFilled = (type: string): boolean => {
      if (type === "user") {
        const formState = loginUser.value?.formState;
        return !!(formState?.username && formState?.Pwd);
      } else if (type === "phone") {
        const formPhone = loginPhone.value?.formPhone;
        return !!(formPhone?.phone && formPhone?.msgCode);
      } else if (type === "all") {
        const activeKey = loginAll.value?.activeKey;
        if (activeKey === "1") {
          const formState = loginAll.value?.loginUser?.formState;
          return !!(formState?.username && formState?.Pwd);
        } else {
          const formPhone = loginAll.value?.loginPhone?.formPhone;
          return !!(formPhone?.phone && formPhone?.msgCode);
        }
      } else if (type === "verifyEmail") {
        return !!verifyProp.value?.email;
      }
      return false;
    };

    // 执行登录的通用方法
    const executeLogin = (type: string) => {
      if (type == "user") {
        userLogin(); // 单账号密码登录
      } else if (type == "phone") {
        phoneLogin(); // 单手机号登录
      } else if (type == "all") {
        allLogin(); // 手机号/ 账号登录
      } else {
        verifyEmailLogin(); // 账号登录 ——> 邮箱验证
      }
    };
    // const privacyHtml = computed(() => {
    //   return t('privacyHtml')
    // })

    // const userAgreementHtml = computed(() => {
    //   return t('userAgreementHtml')
    // })


    const formConfig = reactive({
      loginType: computed(() => {
        return store.state.platConfig.loginType;
      }),
      forgetPwdType: computed(() => {
        return store.state.platConfig.forgetPwdType;
      }),
    });
    // 单点认证
    const commonLogin = async (formState: any, type: string) => {
      const params = {
        baseUrl: store.getters["getBaseUrl"],
        username: type === "1" ? formState.username : formState.phone,
        Pwd:
          type === "1"
            ? encodeURIComponent(encryrt(formState.Pwd))
            : formState.msgCode,
        type: type,
        language: localStorage.getItem('lang') || 'zh-CN',
      };
      const res: any = await login(params);
      window.location.href = res; // 跳转平台
    };
    // 账号密码登录需要二次验证
    const verifyLogin = async (formState: any, type: string) => {
      if (
        type === "1" &&
        JSON.parse(formConfig.loginType).indexOf("verifyEmail") != -1
      ) {
        const params = {
          baseUrl: store.getters["getBaseUrl"],
          account: formState.username,
          password: formState.Pwd,
        };
        const res: any = await verifyAccountSecret(params);
        verifyProp.value = { ...res, params: formState };
        showVerify.value = true;
      } else {
        commonLogin(formState, type);
      }
    };
    // 手机号登录
    const phoneLogin = async () => {
      let res = await loginPhone.value.loginPlatform();
      if (!agreedToTerms.value) {
        pendingLoginType.value = "phone";
        tipModalVisible.value = true;
        return;
      }
      commonLogin(res, "2");
    };
    // 账号密码登录
    const userLogin = async () => {
      const res: any = await loginUser.value.loginPlatform();
      if (!agreedToTerms.value) {
        pendingLoginType.value = "user";
        tipModalVisible.value = true;
        return;
      }
      verifyLogin(res, "1"); // 二次验证 (根据是否开启邮箱验证状态进行二次验证) ps:三级等保
    };
    const allLogin = async () => {
      const res: any = await loginAll.value.loginPlatform();
      if (!agreedToTerms.value) {
        pendingLoginType.value = "all";
        tipModalVisible.value = true;
        return;
      }
      verifyLogin(res, res.type); // 二次验证
    };
    const verifyEmailLogin = async () => {
      const res: any = await loginVerifyEmail.value.loginPlatform();
      if (!agreedToTerms.value) {
        pendingLoginType.value = "email";
        tipModalVisible.value = true;
        return;
      }
      const { params, formEmail } = res;
      console.log(res);
      await checkEmailCode(formEmail);
      await commonLogin(params, "1");
    };
    const loginPt = (type: string) => {
      executeLogin(type);
    };
    const alertMsg = () => {
      message.warn(t('login.warnStr1'));
    };
    const watchUserAction = () => {
      const { visibilityChange } = getVisibility(document);
      document.removeEventListener(
        visibilityChange as keyof DocumentEventMap,
        () => { },
        false
      );
      // 切换浏览器标签 重新请求用户菜单
      document.addEventListener(
        visibilityChange as keyof DocumentEventMap,
        () => {
          // 当且仅当 store 角色id 与 缓存中不一致刷新
          if (document[getVisibilityState() as keyof Document] === "visible") {
            store.dispatch("getUrl");
          }
        },
        false
      );
    };
    onMounted(() => {
      watchUserAction();
      watchKeyBoard();
    });
    const watchKeyBoard = () => {
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == 13) {
          if (
            JSON.parse(formConfig.loginType).indexOf("user") != -1 &&
            JSON.parse(formConfig.loginType).indexOf("phone") != -1 &&
            !showVerify.value
          ) {
            loginPt("all");
          } else if (
            JSON.parse(formConfig.loginType).indexOf("user") != -1 &&
            !showVerify.value
          ) {
            loginPt("user");
          } else if (
            JSON.parse(formConfig.loginType).indexOf("phone") != -1 &&
            !showVerify.value
          ) {
            loginPt("phone");
          } else {
            loginPt("verifyEmail");
          }
        }
      });
    };
    const changeAccount = () => {
      showVerify.value = false;
    };
    const loginWebOut = () => {
      //cookie有登录信息时直接登录
      let loginInfo: any = getCookie("LOGIN_INFO");
      if (loginInfo) {
        loginInfo = JSON.parse(loginInfo);
        let obj = {
          username: loginInfo.accountName,
          Pwd: loginInfo.accountPassword,
        };
        commonLogin(obj, "1");
      }
    };
    loginWebOut();
    return {
      loginAll,
      loginUser,
      loginPhone,
      loginVerifyEmail,
      loginPt,
      alertMsg,
      loginWebOut,
      watchUserAction,
      changeAccount,
      formState: computed(() => {
        return store.state.loginInfo;
      }),
      formConfig,
      showVerify, // 是否显示邮箱验证
      verifyProp, // 验证邮箱回显
      agreedToTerms,
      privacyVisible,
      openPrivacy,
      // privacyHtml,
      userAgreementVisible,
      openUserAgreement,
      // userAgreementHtml,
      tipModalVisible,
      handleAgreeInTip,
      t,
      locale
    };
  },
});
</script>
<style lang="less" scoped>
.home {
  height: 100%;

  .back-home {
    height: 75%;
    width: 100%;
    background: url("@/assets/logo_bg.png") no-repeat top;
    background-size: cover !important;
  }
}

.login-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 16px;
  text-align: center;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  padding: 0 16px;
  z-index: 10;
  user-select: none;
  color: #d7d7d7;
}

.login-footer__line {
  white-space: nowrap;
}

.login-footer__link {
  color: #d7d7d7;
  text-decoration: underline;
  cursor: pointer;
  user-select: text;
}

.privacy-html {
  word-break: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.7;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
}

.privacy-html :deep(h2) {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px;
}

.privacy-html :deep(h3) {
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 8px;
}

.privacy-html :deep(p) {
  margin: 0 0 10px;
}

.privacy-html :deep(ol) {
  padding-left: 20px;
  margin: 0 0 12px;
}

.privacy-html :deep(li) {
  margin: 0 0 6px;
}

.agreement-checkbox {
  margin-top: 16px;
  text-align: left;
}

.agreement-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.5;
}

.agreement-link {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
}

.agreement-link:hover {
  text-decoration: underline;
}

.tip-modal-content {
  padding: 20px 0;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(0, 0, 0, 0.85);
}

.tip-agreement-link {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
}

.tip-agreement-link:hover {
  text-decoration: underline;
}

.enBtn {
  letter-spacing: 0px !important;
}
</style>
<style scoped lang="less" src="@/style/common.less"></style>
